(() => {
  const ARTICLE_LINK_SELECTOR = '.blog-post-content a[href]';
  const LEGACY_HANDLE_OVERRIDES = {
    'new': 'new-cannabis-products',
    'outdoor-grown': 'outdoor-grow',
  };

  /**
   * Normalize legacy French collection aliases embedded in article rich text.
   * Shopify redirects `/fr/collections/{handle}-fr` by prepending the locale
   * from the redirect target, producing `/fr/fr/collections/...` and a 404.
   *
   * @param {string} href
   * @param {{ origin: string }} location
   * @param {string} language
   * @returns {string|null}
   */
  function normalizeHref(href, location, language) {
    if (typeof href !== 'string' || !href) return null;
    if (typeof language !== 'string' || language.toLowerCase().indexOf('fr') !== 0) return null;

    let url;
    try {
      url = new URL(href, location.origin);
    } catch (error) {
      return null;
    }

    if (url.origin !== location.origin) return null;

    const match = /^\/fr\/collections\/([^/]+)-fr\/?$/.exec(url.pathname);
    if (!match) return null;

    const legacyHandle = match[1];
    const canonicalHandle = LEGACY_HANDLE_OVERRIDES[legacyHandle] || legacyHandle;
    url.pathname = `/fr/collections/${canonicalHandle}`;

    return `${url.pathname}${url.search}${url.hash}`;
  }

  function normalizeArticleLinks(scope = document) {
    if (!scope || typeof scope.querySelectorAll !== 'function') return 0;

    let changed = 0;
    const language = document.documentElement.lang || window.Shopify?.locale || '';

    for (const link of scope.querySelectorAll(ARTICLE_LINK_SELECTOR)) {
      const href = link.getAttribute('href');
      const normalizedHref = normalizeHref(href, window.location, language);
      if (!normalizedHref || normalizedHref === href) continue;

      link.setAttribute('href', normalizedHref);
      changed += 1;
    }

    return changed;
  }

  window.OCSArticleLinkLocalization = {
    normalizeArticleLinks,
    normalizeHref,
  };

  normalizeArticleLinks();
})();
